import PropTypes from "prop-types"

import _ from "lodash"

import React, { useEffect, useState, useMemo, useRef} from "react"

import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import { Link, Redirect, useParams  } from "react-router-dom"

import { Formik, Field, ErrorMessage, FieldArray, useFormik } from "formik"

import withRouter from "components/Common/withRouter"

import { getSession, setSession } from "helpers/AuthType/authService"

import classnames from "classnames"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

//Import valadiation Schemas
import { getAccessCodeSchema } from "common/validation-schema"

import {
  applicationResetState,
  applicationAccessCode,
} from "store/actions"

//Import SelectWithValidation
import Toastr from "components/Common/toastr"

//Global Functions
import {
  findElementPositionById,
  regexp,
  showPreloader,
  hidePreloader,
  formatPhoneNumber,
} from "common/global/functions.js"

import AccessCodeForm from "./forms/accessCodeForm"

const AccessCode = props => {
  //meta title
  document.title = "Access Code | Equity Sales Finance, INC."

  const dispatch = useDispatch()

  const params =  useParams();

  let {
    app,
    merchant,
    pagetracker,
  } = getSession();


  const applicantType = props.state.applicantType

  var prev_path =
    applicantType == "coapplicant"
      ? "/co/reference-information"
      : "/reference-information"
      

  const onPreviousBtnClick = path => {
    dispatch(applicationResetState(path, props.router.navigate))
  }

  const [activeTab, setactiveTab] = useState(4)
  const [accessCodeModal, setAccessCodeModal] = useState(false)

  let schema = getAccessCodeSchema(applicantType)

  const formRef = useRef()

  const selectApplicationState = state => state.application
  const ApplicationProperties = createSelector(
    selectApplicationState,
    application => ({
      error: application.error,
      loading: application.loading,
      response: application.response,
    })
  )

  const { error,  loading, response, } = useSelector(
    ApplicationProperties
  ) 
  
  const getAccessCodeMethods = () => {
    let {cellphone,workphone,homephone,email} = app,
    options = [], counter = 0;
  
    _.forOwn({cellphone,workphone,homephone,email}, function (value, key) {
      if(value){
        options[counter] = {
          value: key,
          label: key == 'email' ? `${key} - ${value}` : `${key} - ${formatPhoneNumber(value)}`,
        }
        counter++
      }
    })
    return options;
  }

  const onAccessCodeSelectChange = event => {  
    
    if(_.includes(event.target.option.value, 'phone'))
      setAccessCodeModal(true)
    
    formRef.current.setFieldValue(event.target.name, event.target.option)
  }

  const handleFormSubmit = async () => {
    formRef.current.handleSubmit()
  }

  useEffect(() => {
    if (error) {
      try {
        window.scroll({top: 0,left: 0,behavior: "smooth",})
      } catch (error) {
        window.scrollTo(0, 0)
      }
    }
  }, [error])

  return (
    <React.Fragment>

          {/* Start SMS Data Rates Modal*/}
          <Modal
            isOpen={accessCodeModal}
            backdrop={"static"}
            id="staticBackdrop"
          >
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Access Code Authorization
              </h5>
              {/* <button type="button" className="btn-close"
              onClick={() => {
                  setTermsConditionsModal(!termsConditionsModal);
              }} aria-label="Close"></button> */}
            </div>
            <div className="modal-body">
              <p>
                By selecting this verification method, you agree we may deliver
                a one time access code to you.
              </p>
              <p>Your mobile carrier's messaging and data fees may apply.</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  formRef.current.setFieldValue("access_code_method", null)
                  setAccessCodeModal(!accessCodeModal)
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={e => {
                  //e.preventDefault();
                  setAccessCodeModal(!accessCodeModal)
                  //validation.handleSubmit();
                }}
              >
                Confirm
              </button>
            </div>
          </Modal>
          {/* End SMS Data Rates Modal */}

      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={
              applicantType == "coapplicant"
                ? "Co-Signer"
                : "Applicant"
            }
            breadcrumbItem={"Access Code Authorization"}
          />
          {error ? <Alert color="danger">{error}</Alert> : null}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">One-Time Verification</CardTitle>
                  <p className="card-title-desc">
                  To complete your application, please select a one-time access code option below. This code is required to verify your account and finalize your application.
                    </p>
                  <p className="card-title-desc">
                    {`By selecting an option below, you agree ${merchant.creditor} may deliver a one time verification code to you using the delivery method selected below.`}
                  </p>
                  <p className="card-title-desc">
                    Your mobile carrier's messaging and data fees may apply
                    </p>
                  <div className="wizard clearfix">
                    
                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                      <TabPane tabId={4}>

                          <Formik
                            enableReinitialize={true}
                            innerRef={formRef}
                            initialValues={
                              schema.initialValues
                            }
                            validationSchema={
                              schema.validationSchema
                            }
                            onSubmit={async values => {
                              try {
                                dispatch(applicationAccessCode(applicantType, values, props.router.navigate))
                              } catch (error) {
                                console.error({ error })
                              }
                            }}                            
                            component = {
                              props => <AccessCodeForm 
                              {...props} 
                              accessCodeMethods ={getAccessCodeMethods} 
                              handleAccessCodeSelectChange ={onAccessCodeSelectChange}
                              />
                            }
                          />


                        </TabPane>
                      </TabContent>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            loading
                              ? "previous disabled"
                              : "previous"
                          }
                        >
                          <Link
                            to={"#"}
                            className="btn btn-info btn-block"
                            onClick={e => {
                              e.preventDefault();
                              onPreviousBtnClick(prev_path)
                            }}
                          >
                            Previous
                          </Link>
                        </li>

                        <li className={loading ? "next disabled" : "next"}>
                          <Link
                            to={"#"}
                            onClick={e => {
                              e.preventDefault()
                              handleFormSubmit()
                            }}
                          >
                            {loading ? (
                              <>
                                <Spinner size="sm">Loading...</Spinner>
                                <span> Loading</span>
                              </>
                            ) : (
                              "Next"
                            )}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(AccessCode)

AccessCode.propTypes = {
  history: PropTypes.object,
}
